import { render, staticRenderFns } from "./nopic.vue?vue&type=template&id=c228192a&scoped=true&"
import script from "./nopic.vue?vue&type=script&lang=js&"
export * from "./nopic.vue?vue&type=script&lang=js&"
import style0 from "./nopic.vue?vue&type=style&index=0&id=c228192a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c228192a",
  null
  
)

export default component.exports